import { fileParserService } from "@/services/data/fileParser";

/**
 * Checks if data has geographic information (latitude/longitude columns or geometry)
 * This is a unified helper function to be used everywhere we need to check for geographic data
 * 
 * @param data - Array of data rows (optional, for checking geometry)
 * @param columns - Array of column names (for checking lat/lng columns)
 * @returns Object with hasGeographicData boolean and details
 */
export function hasGeographicData(
  data?: any[],
  columns?: string[]
): {
  hasGeographicData: boolean;
  hasLatLon: boolean;
  hasGeometry: boolean;
  lat?: string;
  lon?: string;
} {
  let hasLatLon = false;
  let hasGeometry = false;
  let lat: string | undefined;
  let lon: string | undefined;

  // Check for lat/lng columns if columns are provided
  if (columns && columns.length > 0) {
    const latLonCheck = fileParserService.hasLatLonColumns(columns);
    hasLatLon = latLonCheck.has;
    lat = latLonCheck.lat;
    lon = latLonCheck.lon;
  }

  // Check for geometry data if data rows are provided
  if (data && data.length > 0) {
    hasGeometry = fileParserService.hasGeometryData(data);
  }

  return {
    hasGeographicData: hasLatLon || hasGeometry,
    hasLatLon,
    hasGeometry,
    lat,
    lon,
  };
}

